

import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMenu, setMobileMenu] = useState(null);

  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMenu(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenu(null);
  };

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Portfolio", path: "/portfolio" },
    { label: "Services", path: "/services" },
    { label: "About Us", path: "/about-us" },
    { label: "Contact Us", path: "/contact-us" },
    { label: "FAQ", path: "/faq" }, // Added FAQ Link
  ];

  const blogLinks = [
    { label: "Videos", path: "/blogs/videos" },
    { label: "Gallery", path: "/blogs/gallery" },
  ];

  return (
    <AppBar position="static" sx={{ backgroundColor: "#333" }}>
      <Toolbar>
        {/* Logo */}
        <Typography
          variant="h6"
          component={Link}
          to="/"
          sx={{
            flexGrow: 1,
            textDecoration: "none",
            color: "inherit",
            fontWeight: "bold",
          }}
        >
          Wedding Bliss
        </Typography>

        {/* Desktop Menu */}
        <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
          {navLinks.map((link) => (
            <Button
              key={link.label}
              component={Link}
              to={link.path}
              sx={{ color: "#fff", textTransform: "none" }}
            >
              {link.label}
            </Button>
          ))}

          {/* Blogs Dropdown */}
          <Button
            sx={{ color: "#fff", textTransform: "none" }}
            onClick={handleDropdownOpen}
          >
            Blogs
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleDropdownClose}
          >
            {blogLinks.map((link) => (
              <MenuItem
                key={link.label}
                component={Link}
                to={link.path}
                onClick={handleDropdownClose}
              >
                {link.label}
              </MenuItem>
            ))}
          </Menu>
        </Box>

        {/* Mobile Menu */}
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <IconButton
            color="inherit"
            onClick={handleMobileMenuOpen}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={mobileMenu}
            open={Boolean(mobileMenu)}
            onClose={handleMobileMenuClose}
          >
            {navLinks.map((link) => (
              <MenuItem
                key={link.label}
                component={Link}
                to={link.path}
                onClick={handleMobileMenuClose}
              >
                {link.label}
              </MenuItem>
            ))}
            <MenuItem onClick={handleDropdownOpen}>Blogs</MenuItem>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleDropdownClose}
            >
              {blogLinks.map((link) => (
                <MenuItem
                  key={link.label}
                  component={Link}
                  to={link.path}
                  onClick={() => {
                    handleDropdownClose();
                    handleMobileMenuClose();
                  }}
                >
                  {link.label}
                </MenuItem>
              ))}
            </Menu>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
